import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Heading, Text, Button, Flex } from '@chakra-ui/react';

export default function NotFound() {
  return (
    <Flex minHeight="80vh" alignItems="center" justifyContent="center">
      <Box textAlign="center" p={8}>
        <Heading as="h1" size="2xl" color="red.500" mb={4}>
          404
        </Heading>
        <Text fontSize="xl" mb={6}>
          页面未找到
        </Text>
        <Text color="gray.500" mb={8}>
          您访问的页面不存在或已被移除
        </Text>
        <Button as={Link} to="/" colorScheme="blue">
          返回首页
        </Button>
      </Box>
    </Flex>
  );
} 